import React from 'react'

const Empty = ({children}) => {
  return <>{children}</>
}

export default Empty
